export class ValidationError extends Error {
  public issues: { message: string }[];

  constructor(public validation: Sentinel.Validation) {
    super("Erro de validação");
    this.name = "ValidationError";
    
    this.issues = Object.entries(validation?.errors || {}).map((issue) => ({
      message: issue[1].join("\n"),
    }));
  }
}